
// src/pages/Community.tsx
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
const Community = () => {
  const navigate = useNavigate();
  return <MainLayout>
      <div className="container mx-auto p-6">
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
          <h1 className="text-3xl font-bold mb-4">Comunidade</h1>
          <Card className="w-full max-w-md p-8">
            <CardContent className="space-y-4">
              <div className="text-5xl mb-4">🔜</div>
              <h2 className="text-xl font-semibold">Em breve!</h2>
              <p className="text-gray-500">
                Estamos trabalhando em uma comunidade incrível para você compartilhar experiências e se conectar com outras pessoas.
              </p>
              <Button onClick={() => navigate('/')} className="mt-4">
                Voltar para Home
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </MainLayout>;
};
export default Community;
